import React from 'react';
import {FormattedMessage} from 'react-intl';
import {useSelector, shallowEqual} from 'react-redux';
import {RootState} from '../../../../store/configureStore';
import {formatUserFullName} from '../../../../common/utils';
import styles from './PaymentPageTitle.module.scss';

const PaymentPageTitle = () => {
  const user = useSelector((state: RootState) => state.auth.user, shallowEqual);
  const name = formatUserFullName(user);

  return (
    <div className={styles.title}>
      <FormattedMessage
        id={'payment-page-title'}
        defaultMessage={'Payment for agent'}
        values={{name}}
      />
    </div>
  );
};

export default PaymentPageTitle;
